var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserRejected = function SvgUserRejected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5242 0H24.4538C24.432 0 24.4102 0.0235385 24.4102 0.0705769V99.9295C24.4102 99.953 24.432 100 24.4757 100H75.5242C75.546 100 75.5897 99.9765 75.5897 99.9295V0.0705769C75.5897 0.0470385 75.5679 0 75.5242 0Z",
    fill: "#F7B548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5293 2.58718C26.5293 2.56364 26.5512 2.5166 26.5949 2.5166H73.6023C73.6242 2.5166 73.6679 2.54014 73.6679 2.58718V97.2473C73.646 97.2708 73.6242 97.2943 73.6023 97.2943H26.5948C26.573 97.2943 26.5293 97.2708 26.5293 97.2237V2.58718H26.5293Z",
    fill: "#FFD590"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5341 52.9287H51.9111V92.0646H68.5341V52.9287Z",
    fill: "#F7B548"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6074 56.0576H54.8604V88.9126H65.6074V56.0576Z",
    fill: "#FFD590"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1542 52.9287H31.5312V92.0646H48.1542V52.9287Z",
    fill: "#F7B548"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.205 56.0576H34.458V88.9126H45.205V56.0576Z",
    fill: "#FFD590"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4488 56.6823H27.7037C27.3242 56.6823 27.0166 56.351 27.0166 55.9424V46.4665C27.0166 46.0579 27.3242 45.7266 27.7037 45.7266H30.4488C30.8283 45.7266 31.1359 46.0579 31.1359 46.4665V55.9424C31.136 56.3511 30.8283 56.6823 30.4488 56.6823Z",
    fill: "url(#paint0_radial_18294_82460)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5768 52.1612H29.1611C28.721 52.1612 28.3643 51.777 28.3643 51.3031V50.6042C28.3643 50.1303 28.721 49.7461 29.1611 49.7461H35.5768C36.0169 49.7461 36.3737 50.1303 36.3737 50.6042V51.3031C36.3737 51.777 36.0169 52.1612 35.5768 52.1612Z",
    fill: "#C8C6C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1542 7.1123H31.5312V48.9064H48.1542V7.1123Z",
    fill: "#F7B548"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5341 7.1123H51.9111V48.9064H68.5341V7.1123Z",
    fill: "#F7B548"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5025 9.27637H53.9424V46.695H66.5025V9.27637Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1226 9.27637H33.5625V46.695H46.1226V9.27637Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5031 20.3955V46.7187H53.9648V26.7705L66.5031 20.3955Z",
    fill: "#F3F2F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1007 30.7227V46.7189H33.5625V37.0976L46.1007 30.7227Z",
    fill: "#F3F2F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2818 59.585H13.0518V98.2346H16.2818V59.585Z",
    fill: "url(#paint1_radial_18294_82460)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7649 99.9998H10.5684L14.6229 94.9443L18.7649 99.9998Z",
    fill: "#C8C6C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 63.9183C16.3901 63.9183 17.7869 62.414 17.7869 60.5583C17.7869 58.7026 16.3901 57.1982 14.6669 57.1982C12.9438 57.1982 11.5469 58.7026 11.5469 60.5583C11.5469 62.414 12.9438 63.9183 14.6669 63.9183Z",
    fill: "#C8C6C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9478 59.585H83.7178V98.2346H86.9478V59.585Z",
    fill: "url(#paint2_radial_18294_82460)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4319 99.9998H81.2354L85.2899 94.9443L89.4319 99.9998Z",
    fill: "#C8C6C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3329 63.9183C87.0561 63.9183 88.453 62.414 88.453 60.5583C88.453 58.7026 87.0561 57.1982 85.3329 57.1982C83.6098 57.1982 82.2129 58.7026 82.2129 60.5583C82.2129 62.414 83.6098 63.9183 85.3329 63.9183Z",
    fill: "#C8C6C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.88 74.3468C49.7682 74.3468 49.6575 74.3463 49.5455 74.3458C37.0005 74.2837 25.7867 70.6816 18.7795 64.4639C18.2842 64.0247 18.2137 63.2362 18.6215 62.7026C19.0301 62.17 19.762 62.0941 20.2568 62.5327C26.8581 68.3903 37.5372 71.7841 49.5563 71.8442C62.0128 71.8908 72.5891 68.42 79.3245 62.0289C79.8052 61.5728 80.5398 61.6221 80.9643 62.1408C81.3883 62.659 81.3416 63.4495 80.8605 63.9067C73.7591 70.6447 62.766 74.3468 49.88 74.3468Z",
    fill: "#E3646A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5178 65.5994C20.5955 65.5994 21.4691 64.6586 21.4691 63.4979C21.4691 62.3373 20.5955 61.3965 19.5178 61.3965C18.4401 61.3965 17.5664 62.3373 17.5664 63.4979C17.5664 64.6586 18.4401 65.5994 19.5178 65.5994Z",
    fill: "#605D5A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.092 65.0691C81.1697 65.0691 82.0433 64.1283 82.0433 62.9677C82.0433 61.8071 81.1697 60.8662 80.092 60.8662C79.0143 60.8662 78.1406 61.8071 78.1406 62.9677C78.1406 64.1283 79.0143 65.0691 80.092 65.0691Z",
    fill: "#605D5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18294_82460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1353 51.1384) scale(3.88051 4.17901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#7B7875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#979492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#ACAAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5131,
    stopColor: "#BCBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#C5C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C6C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18294_82460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5715 60.9147) scale(12.7442 13.7245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#7B7875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#979492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#ACAAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5131,
    stopColor: "#BCBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#C5C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C6C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_18294_82460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.2388 60.7612) scale(12.7442 13.7245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#7B7875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#979492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#ACAAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5131,
    stopColor: "#BCBAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#C5C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C6C4"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserRejected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-rejected.f6b802ee.svg";